import React, { useEffect, useState } from "react";
import { Col, Row, Card, Button } from "antd";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import InfoMenu from "../components/InfoMenu";
import DynamicScript from "../components/DynamicScript";
import EmbedScript from "../components/EmbedScript";
import { ReactComponent as Download } from "../assets/icons/Download.svg";
const Image1 = require("../assets/original/3e4e1641d9.png");

export default function PictonEmbeds() {
    const [activeLink, setActiveLink] = useState("tripPlanner");
    //const [isTownlink, setisTownlink] = useState(false);
    //const [townLink, setTownLink] = useState();

    useEffect(() => {
        document.body.classList.add("PagePictonEmbeds");
        return () => {
            document.body.classList.remove("PagePictonEmbeds");
        };
    }, []);

    useEffect(() => {
        // Parse the query parameters
        const queryParams = new URLSearchParams(window.location.search);
        const routePath = window.location.pathname;
        // Check if 'timetables' query parameter is present and set to 'true'
        if (routePath?.includes('trip-planner-timetables')) {
            setActiveLink('tripPlanner');
        }
        if (routePath?.includes('school-trip-planner-timetables')) {
            setActiveLink('schoolList');
          }
        // if (queryParams?.get('townlink')) {
        //   setisTownlink(true);
        //   setTownLink(queryParams?.get('townlink'));
        // }
    }, []);

    const showStyle = (link) => {
        console.log(link, activeLink);
        if (link !== activeLink) {
            return { style: { display: "none" } };
        }
        return {};
    };

    return (
        <div className="PictonEmbeds PageSingle" style={{ paddingBottom: "50px" }}>
            {/* {isTownlink ?
                <section
                    className="PageHero Cover"
                    style={{ backgroundImage: `url(${Image1})` }}
                >
                    <div className="AppContainer">
                        <h1 className="title" style={{ marginBottom: "8px" }}>
                            {townLink}
                        </h1>
                        <Button href="/town-link" size="small" className="mt-20 light" type="primary">Back to Town-link</Button>
                        <div className="InfoMenu">
                            <ul>
                                <li style={{borderRadius: '18px'}}><Link to="https://lms-prod-media-assets.s3.ap-southeast-2.amazonaws.com/2023_16_cities_update_OGDENS_townlink_tt_Tf_NSW_v2_5ad18239df.pdf" target="_blank"><Download /> Download Timetable</Link></li>
                            </ul>
                        </div>
                    </div>
                </section>
            : */}
                <section
                    className="PageHero Cover"
                    style={{ backgroundImage: `url(${Image1})` }}
                >
                    <div className="AppContainer">
                        <h1 className="title" style={{ marginBottom: "8px" }}>Trip Planner and Timetables</h1>
                        {/* <h2 className="title" style={{ marginBottom: "0" }}>Picton Buslines' Trip Planner</h2> */}
                        <InfoMenu activeLink={activeLink} setActiveLink={setActiveLink} />
                    </div>
                </section>
            {/* } */}
            <div className="AppContainer">
                <Row gutter={[20, 0]}>
                    <Col xs={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }}>
                        <Card bordered={false} className="CardEmbed">
                            {/* {activeLink} */}
                            <div id="busable_trip_planner" {...showStyle("tripPlanner")}></div>
                            <div id="busable_school_list" {...showStyle("schoolList")}></div>
                            <div id="busable_timetables" {...showStyle("timetables")}>
                                <div style={{fontSize: 18, textAlign: 'center', width: '100%', maxWidth: '800px', margin: '0 auto 40px', color: '#777'}}>You can access the Picton Buslines' routes 900, 901, 911, 912, 913, 914, 915 and 828*. All routes and times are up to date unless otherwise specified.</div>
                                <ul className="CardList">
                                    <li><a href="https://transportnsw.info/routes/details/sydney-and-surrounds-network/900/58900" target="_blank" rel="noreferrer">Route <strong>900</strong> Picton to Camden, Narellan & Campbelltown via Jarvisfield</a></li>
                                    <li><a href="https://transportnsw.info/routes/details/sydney-and-surrounds-network/901/58901" target="_blank" rel="noreferrer">Route <strong>901</strong> Picton to Wilton via Douglas Park</a></li>
                                    <li><a href="https://transportnsw.info/routes/details/sydney-and-surrounds-network/911/58911" target="_blank" rel="noreferrer">Route <strong>911</strong> Picton to Bargo & Yanderra via Tahmoor</a></li>
                                    <li><a href="https://transportnsw.info/routes/details/sydney-and-surrounds-network/912/58912" target="_blank" rel="noreferrer">Route <strong>912</strong> Picton to Tahmoor via Thirlmere</a></li>
                                    <li><a href="https://transportnsw.info/routes/details/sydney-and-surrounds-network/913/58913" target="_blank" rel="noreferrer">Route <strong>913</strong> Buxton to Picton via Tahmoor</a></li>
                                    <li><a href="https://transportnsw.info/routes/details/sydney-and-surrounds-network/914/58914" target="_blank" rel="noreferrer">Route <strong>914</strong> Picton to Buxton via Thirlmere & Tahmoor</a></li>
                                    <li><a href="https://transportnsw.info/routes/details/sydney-and-surrounds-network/915/58915" target="_blank" rel="noreferrer">Route <strong>915</strong> Picton to Nangarin Vineyard Estate
                                    via Barkers Lodge Rd</a></li>
                                    <li><a href="https://transportnsw.info/routes/details/south-east-and-tablelands-network/828/57828" target="_blank" rel="noreferrer">Route <strong>828</strong> Picton to Bowral via Thirlmere, Couridjah, Buxton, Balmoral Village & Hill Top <span>*operated by Berrima Buslines</span></a></li>
                                </ul>
                            </div>
                            {/* <EmbedScript src="https://enable.busable.app/busable.embed.js?operator_id=ogdens_orana&views=trip_planner,school_list,timetables" /> */}
                            <Helmet>
                                <script src="https://enable.busable.app/busable.embed.js?operator_id=blpctn&views=trip_planner,school_list"></script>
                            </Helmet>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
